module.exports = __webpack_public_path__ + "img/maze_triangular_g.a590f7c7.svg";